const memberEntities = {
  USER: 'user',
  USERGROUP: 'usergroup',
};

export default memberEntities;
